export default __webpack_public_path__ + "static/media/calculator.f116c80d.webp";